const PlaceholderImageIcon = ({ viewBox = "0 0 82 82", className = "hayley-h-[35px] hayley-w-[35px]" }) => {
  return (
    <svg data-testid="placeholder-img-icon" viewBox={viewBox} fill="none" className={className}>
      <path
        d="M74 0.5H8C3.85786 0.5 0.5 3.85786 0.5 8V74C0.5 78.1421 3.85786 81.5 8 81.5H74C78.1421 81.5 81.5 78.1421 81.5 74V8C81.5 3.85786 78.1421 0.5 74 0.5Z"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.5 66.5L23 44L33.5 56L51.5 32L72.5 66.5H9.5Z" stroke="#999999" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M28.25 30.5C32.8063 30.5 36.5 26.8063 36.5 22.25C36.5 17.6937 32.8063 14 28.25 14C23.6937 14 20 17.6937 20 22.25C20 26.8063 23.6937 30.5 28.25 30.5Z"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlaceholderImageIcon;
